var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ReportContainer',{attrs:{"token":_vm.token,"shopping-only":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }